/** High-contrast chrome for the standalone ICS-234 matrix on dark IAP panels. */

export const MATRIX_KIND_BADGE =
  'tw:border-neutral-500 tw:bg-neutral-800 tw:text-white tw:text-xs';

export const MATRIX_META_BADGE =
  'tw:border-transparent tw:bg-neutral-300 tw:text-neutral-950 tw:text-xs';

export const MATRIX_TRASH_BTN =
  'tw:text-red-500! tw:hover:text-red-400! tw:disabled:text-red-500/40!';

export const MATRIX_ICON_BTN = 'tw:text-white! tw:hover:bg-neutral-800';

export const MATRIX_OUTLINE_BTN =
  'tw:border-neutral-500 tw:bg-neutral-900 tw:text-white tw:hover:bg-neutral-800';
